import { Box, Button, Typography } from "@mui/material";
import { RightArrow } from "../../utils/icon/Landing-Page/Icon";
import { CardData, FPImgData } from "../../utils/data/Landing-Page/data";
import { BenefitsCard, ImgHover2 } from "./LandingPageElements";



export const FourthPage = () => {
    return (
        <Box sx={{ background: '#F3F5F7' }}>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Box sx={{ width: '80%', py: 3, pb: 6 }}>
                    <Typography sx={{ fontSize: '20px', color: '#0057D5', fontWeight: '700', py: 4 }}>BENEFITS</Typography>
                    <Typography sx={{ fontSize: '40px', color: '#040815', fontWeight: '700', py: 2 }}>Transformative Benefits for<br /> Your Success</Typography>
                    <Typography sx={{ fontSize: '20px', color: '#474747', fontWeight: '500', py: 2 }}>Understand how our platform drive efficiency, security, and collaboration.<br />
                        Experience the full potential of optimized project management.</Typography>
                    <Button sx={{ color: '#fff', background: '#FF2800', height: '40px', my: 2, mb: 4, borderRadius: '40px', mx: '10px', textTransform: 'capitalize', '&:hover': { background: '#FF280099' }, px: 3 }}><Typography sx={{ mr: 2 }}>Explore Benefits</Typography><RightArrow /></Button>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Box sx={{ maxWidth: '500px' }}>
                            {CardData.map((e, i) => (
                                <BenefitsCard key={i} data={e} />
                            ))}
                        </Box>
                        {/* <Box sx={{ width: '50%', display: 'flex', justifyContent: 'end'}}> */}
                            <ImgHover2 data={FPImgData} />
                        {/* </Box> */}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}